import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  @media (max-width: 768px) {
    flex-direction: column-reverse;
    align-items: center;
    gap: 16px;
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Title = styled.div`
  font-weight: bold;
  font-size: 2.5rem;
  font-family: "BroadwayD";
  line-height: 1.1;
  @media (max-width: 768px) {
    text-align: center;
    font-size: 2rem;
  }
`;

export const GradientText = styled.span`
  background: linear-gradient(135deg, #f990e8, #0bd2d3);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
`;

export const SubTitle = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #666;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  @media (max-width: 768px) {
    text-align: center;
  }
`;
